// get the int value and increase it by one
module.exports = (value: string, options: any) => parseInt(value) + 1;
